/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

interface Props extends React.PropsWithChildren {
  title?: React.ReactNode;
}

const styles = {
  subsection: css`
    margin-bottom: var(--cds-spacing-300);

    &:last-of-type {
      margin-bottom: 0;
    }
  `,
  subsectionTitle: css`
    margin-bottom: var(--cds-spacing-100);
  `,
};

const Subsection = ({ title, children }: Props) => {
  return (
    <div css={styles.subsection}>
      {title && <div css={styles.subsectionTitle}>{title}</div>}
      {children}
    </div>
  );
};

export default Subsection;
